import { render, staticRenderFns } from "./ShopSwiper.vue?vue&type=template&id=76791fc6&scoped=true&"
import script from "./ShopSwiper.vue?vue&type=script&lang=js&"
export * from "./ShopSwiper.vue?vue&type=script&lang=js&"
import style0 from "./ShopSwiper.vue?vue&type=style&index=0&id=76791fc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76791fc6",
  null
  
)

export default component.exports